import React from 'react';

const Terms = () => (
  <div className="container my-5">
    <div className="text-center mb-4">
      <h2 className="fw-bold">Terms & Conditions</h2>
      <p className="text-muted">Last updated: April 16, 2025</p>
    </div>

    <div className="mb-4">
      <h4>1. Acceptance of Terms</h4>
      <p>
        By accessing or using PharmaCart, you agree to be bound by these Terms and Conditions and our Privacy Policy. If you do not agree with any part of these terms, please do not use our services.
      </p>
    </div>

    <div className="mb-4">
      <h4>2. Products & Services</h4>
      <p>
        PharmaCart provides medicines, wellness products, and healthcare items for personal use only. Prescription-required drugs must be accompanied by a valid prescription. We reserve the right to cancel any order that does not comply with our policies.
      </p>
    </div>

    <div className="mb-4">
      <h4>3. Pricing & Payments</h4>
      <p>
        All prices are listed in INR and are subject to change without prior notice. We accept various payment methods, including cards, UPI, and COD (where applicable). Orders are confirmed only after successful payment or verification.
      </p>
    </div>

    <div className="mb-4">
      <h4>4. Shipping & Delivery</h4>
      <p>
        We aim to deliver products within 1–3 business days. However, delivery timelines may vary due to location, availability, or unforeseen circumstances. PharmaCart is not liable for delays caused by logistics partners.
      </p>
    </div>

    <div className="mb-4">
      <h4>5. Cancellations & Refunds</h4>
      <p>
        Orders can be canceled before they are dispatched. Refunds are provided for damaged, expired, or incorrect items only. Requests must be raised within 48 hours of delivery. Refer to our Return Policy for more information.
      </p>
    </div>

    <div className="mb-4">
      <h4>6. User Conduct</h4>
      <p>
        You agree not to misuse our platform, engage in fraudulent activity, or violate any applicable laws. PharmaCart reserves the right to suspend or terminate accounts that violate these terms.
      </p>
    </div>

    <div className="mb-4">
      <h4>7. Limitation of Liability</h4>
      <p>
        PharmaCart is not liable for any indirect or incidental damages arising from the use or inability to use our platform, including but not limited to loss of data, profits, or health outcomes due to reliance on provided information.
      </p>
    </div>

    <div className="mb-4">
      <h4>8. Changes to Terms</h4>
      <p>
        We may update these Terms & Conditions from time to time. Continued use of the platform after changes signifies your acceptance of the updated terms.
      </p>
    </div>

    <div className="text-center mt-5">
      <p className="text-muted">For questions, contact our support team at <a href="mailto:support@pharmacart.com">support@pharmacart.com</a></p>
    </div>
  </div>
);

export default Terms;
